import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicHeader from '../../components/PublicHeader';
import Footer from '../../components/Footer';
import { useAuthContext } from '../../context/AuthContext';
import { PRIVACY_SECTIONS_INSPECTOR } from './privacyContent';
import './PrivacyPage.css';

const PrivacyPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthContext();

  const goBack = () => {
    navigate(isAuthenticated ? '/' : '/login');
  };

  return (
    <div className="privacy-legal-page">
      <PublicHeader />

      <main className="privacy-legal-page__wrapper">
        <div className="privacy-legal-page__container">
          <header className="privacy-legal-page__header">
            <h1>Privacidad y tratamiento de datos</h1>
            <p className="privacy-legal-page__subtitle">
              Información sobre el uso de datos personales y tecnologías del navegador en IVISNK9 Inspector.
            </p>
          </header>

          <div className="privacy-legal-page__scroll">
            {PRIVACY_SECTIONS_INSPECTOR.map((section) => (
              <article key={section.title} className="privacy-legal-section">
                <h2>{section.title}</h2>
                {section.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </article>
            ))}
          </div>

          <button
            type="button"
            className="privacy-legal-page__back"
            onClick={goBack}
          >
            {isAuthenticated ? 'Volver al inicio' : 'Ir al inicio de sesión'}
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
